import React from "react";
import { Dialog, Box, IconButton, Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ImageZoomModalProps {
  open: boolean;
  onClose: () => void;
  src?: string;
  alt?: string;
  initials?: string;
  bgColor?: string;
  textColor?: string;
}

const ImageZoomModal: React.FC<ImageZoomModalProps> = ({
  open,
  onClose,
  src,
  alt,
  initials,
  bgColor,
  textColor,
}) => {
  const handleClose = (e: React.MouseEvent | React.KeyboardEvent | {}) => {
    if (e && (e as React.MouseEvent).stopPropagation) {
      (e as React.MouseEvent).stopPropagation();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      maxWidth="md"
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          overflow: "visible",
        },
      }}
    >
      <Box
        sx={{ position: "relative", padding: 2 }}
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: -10,
            right: -10,
            color: "white",
            backgroundColor: "rgba(0,0,0,0.5)",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        {src ? (
          <img
            src={src}
            alt={alt || "Zoomed preview"}
            style={{
              maxWidth: "80vw",
              maxHeight: "80vh",
              borderRadius: "8px",
              display: "block",
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
            }}
          />
        ) : (
          <Avatar
            sx={{
              width: 200,
              height: 200,
              fontSize: 80,
              bgcolor: bgColor || "#ccc",
              color: textColor || "#fff",
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
            }}
          >
            {initials}
          </Avatar>
        )}
      </Box>
    </Dialog>
  );
};

export default ImageZoomModal;
